import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {UserSessionDto} from '../../../Models/User/user-session.interface';
import {RegisterForm} from '../../../Models/Auth/register.model';
import {LoginForm} from '../../../Models/Auth/login.model';
import {ForgetPassForm} from '../../../Models/Auth/forget-pass.model';
import {SessionStoreForm} from '../../../Models/Multisession/session-store.model';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
  ) {
    super(injector);
  }


  /**
   * Iniciar sesión
   *
   */
  public login(form: LoginForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpBaseCall('login', form).subscribe({
        next: (response) => {

          if (response.status === 1) {
            this.user = this.userSession.set(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Registrarse
   *
   */
  public register(form: RegisterForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpBaseCall('register', form).subscribe({
        next: (response) => {

          if (response.status === 1) {
            this.user = this.userSession.set(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Salir de la sesión
   *
   */
  logout(): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('logOut', {}).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**+
   * Enviar email con el código
   *
   */
  public sendEmail(form: ForgetPassForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpBaseCall('sendResetPasswordCode', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });
    });
  }


  /**
   * Comprobar el código del email
   *
   */
  public checkCode(form: ForgetPassForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpBaseCall('checkResetPasswordCode', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });
    });
  }


  /**
   * Guardar nueva contraseña
   *
   */
  public resetPassword(form: ForgetPassForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpBaseCall('resetPassword', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });
    });
  }


  /**
   * Obtener la sesión actual desde el servidor
   *
   */
  getSession(): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getUserSession', null, 'get').subscribe({
        next: (response) => {

          if (response.status === 1) {
            this.user = this.userSession.set(response.data);
          }

          resolve(response);

        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Establecer una sesión por pin
   *
   */
  setSessionByPin(params: SessionStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setLoginByPin', params, 'post', true).subscribe({
        next: (response) => {

          if (response.status === 1) {
            this.user = this.userSession.set(response.data);
          }

          resolve(response);

        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener la sesión actual
   *
   */
  getUserSession() {
    this.user = this.userSession.get();
    return this.user;
  }


  /**
   * Actualizar la sesión actual
   *
   */
  public setUserSession(user: UserSessionDto) {
    this.user = this.userSession.set(user);
    return this.user;
  }


  /**
   * Eliminar la sesión actual
   *
   */
  public deleteUserSession() {
    this.user = this.userSession.delete();
  }


  /**
   * Comprobar si el usuario tien una sesión
   *
   */
  public userIsLogIn(): boolean {
    this.user = this.userSession.get();
    return (this.user && 'id' in this.user && 'token' in this.user) || false;
  }

}
